export default "__VITE_ASSET__yrpIdFvj__"